import type { User } from '@/@types/user'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import Avatar from '../../Avatar'
import PostHeader from '../PostHeader'
import styles from './UserCard.module.css'

export interface UserCardProps extends HTMLAttributes<HTMLDivElement> {
	data: User | undefined
}

export default function UserCard({ data, className, ...props }: UserCardProps) {
	if (!data) return null
	return (
		<div className={clsx(styles.root, className)} {...props}>
			<Avatar as="div" data={data} className={styles.avatar} />

			<PostHeader
				title={data.screenName}
				desc={<div className={styles.desc}>{data.briefIntro}</div>}
			/>
		</div>
	)
}
